module.exports = __webpack_public_path__ + "static/media/logo02.de420e5a.svg";